import { AbstractControl, ValidationErrors, ValidatorFn, FormArray, FormGroup } from '@angular/forms';

export function oneOfTheArrayMustBeActive(...params: string[]): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const thereIsOneActive = params
      .some((controlName) => (control.get(controlName) as FormArray)
        .controls.map((formGroup) => (formGroup as FormGroup).controls.active.value)
        .some((isActive) => isActive));

    if (!thereIsOneActive) {
      return {
        description: `Debe seleccionar una casilla en uno de estos controles: ${params.join(', ')}`,
        hidden: true,
      };
    }
    return null;
  };
}

export function oneMustBeActiveOneOfEach(...params: string[]): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const thereIsOneActive = params
      .every((controlName) => (control.get(controlName) as FormArray)
        .controls.map((formGroup) => (formGroup as FormGroup).controls.active.value)
        .some((isActive) => isActive));

    if (!thereIsOneActive) {
      return {
        description: `Debe seleccionar una casilla en cada uno de estos controles: ${params.join(', ')}`,
        hidden: true,
      };
    }
    return null;
  };
}

// 20260615: Se actualizan funciones para funcionar con días y no con diferencia de meses (30 días máximo) se mantienen los nombres

// export function dateRangeConstraintByMonths(dateStartControlName: string, dateEndControlName: string, months: number): ValidatorFn {
//   return (control: AbstractControl): ValidationErrors | null => {
//     const dateStart = control.get(dateStartControlName);
//     const dateEnd = control.get(dateEndControlName);
//     if (dateStart && dateEnd) {
//       if (dateStart.value && dateEnd.value) {
//         const differenceInMonths = monthDiff(dateStart.value, dateEnd.value);
//         if (differenceInMonths >= months) {
//           return {
//             description: `Debe ingresar un rango de fechas menor a ${months} mes.`,
//             hidden: false,
//             code: '300',
//           };
//         }
//       }
//     }
//     return null;
//   };
// }

// function monthDiff(d1: Date, d2: Date) {
//   let months;
//   months = (d2.getFullYear() - d1.getFullYear()) * 12;
//   months -= d1.getMonth();
//   months += d2.getMonth();
//   return months <= 0 ? 0 : months;
// }

export function dateRangeConstraintByMonths(dateStartControlName: string, dateEndControlName: string, months: number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    // la variable months corresponde a días
    const dateStart = control.get(dateStartControlName);
    const dateEnd = control.get(dateEndControlName);
    if (dateStart && dateEnd) {
      if (dateStart.value && dateEnd.value) {
        const differenceInMonths = monthDiff(dateStart.value, dateEnd.value);
        if (differenceInMonths >= months) {
          return {
            description: `Debe ingresar un rango de fechas menor o igual a ${months} días.`,
            hidden: false,
            code: '300',
          };
        }
      }
    }
    return null;
  };
}

function monthDiff(d1: Date, d2: Date) {
  // la variable months corresponde a dias en este casos
  let months;
  let diff;
  diff = d2.getTime() - d1.getTime();
  months = diff / (1000 * 60 * 60 * 24);
  
  return months <= 0 ? 0 : months;
}
